













































































































import { Vue, Component, Watch } from "vue-property-decorator";
import {
  countyCommunityMapHistoryModule,
  MAP_HISTORY_START_MONTH,
  buildMonthList,
  latestDisplayMonth,
  shiftMonth,
  monthToIndex,
  isMonthInRange
} from "@/store/modules/countyCommunityMapHistory";

interface CommunityItem {
  id: string;
  town: string;
  total: number;
  coords: { top: number; left: number };
  hasData: boolean;
  bp: number[];
  grip: number[];
  bmi: number[];
  frailty: number[];
}

@Component
export default class CountyCommunityMapHistory extends Vue {
  public selectedMonth: string = latestDisplayMonth();

  // Material Icons 定義
  public icons = [
    { iconContent: 'favorite', key: 'bp', title: '血壓', label: '血壓' },
    { iconContent: 'sports_mma', key: 'grip', title: '握力', label: '握力' },
    { iconContent: 'man', key: 'bmi', title: 'BMI', label: 'BMI' },
    { iconContent: 'directions_walk', key: 'frailty', title: '活動力', label: '走路或坐站' }
  ];

  get monthItems() {
    return buildMonthList(MAP_HISTORY_START_MONTH, latestDisplayMonth()).map(ym => ({
      text: this.formatMonth(ym),
      value: ym
    }));
  }

  // 直接在 computed 內讀 monthCache，Vue.set 新增 key 時才會通知到
  get entry() {
    return countyCommunityMapHistoryModule.monthCache[this.selectedMonth];
  }

  get loading(): boolean {
    return !this.entry || this.entry.status === 'loading';
  }

  get isEmpty(): boolean {
    return !!this.entry && this.entry.status === 'empty';
  }

  get isError(): boolean {
    return !!this.entry && this.entry.status === 'error';
  }

  get communityData(): CommunityItem[] {
    const posData = countyCommunityMapHistoryModule.posData;
    if (!posData) return [];

    const rows = this.entry && this.entry.status === 'ready' ? this.entry.rows : [];
    const byCode: { [code: string]: TODO } = {};
    rows.forEach((row: TODO) => {
      if (row && row.fullcode) byCode[row.fullcode] = row;
    });

    // 迭代 posData 而非 rows：各月份的 pin 集合固定不變，切月時 pin 不會忽隱忽現
    return Object.keys(posData).map(fullcode => {
      const coords = posData[fullcode];
      const item = byCode[fullcode];
      if (!item) {
        return {
          id: fullcode,
          town: fullcode,
          total: 0,
          coords: { top: coords.top, left: coords.left },
          hasData: false,
          bp: [0, 0, 0, 0],
          grip: [0, 0, 0, 0],
          bmi: [0, 0, 0, 0],
          frailty: [0, 0, 0, 0]
        };
      }
      return {
        id: fullcode,
        town: item.TOWNNAME,
        total: item.total,
        coords: { top: coords.top, left: coords.left },
        hasData: true,
        bp: [item.bp_red, item.bp_yellow, item.bp_green, item.bp_blue],
        grip: [item.grip_red, item.grip_yellow, item.grip_green, item.grip_blue],
        bmi: [item.bmi_red, item.bmi_yellow, item.bmi_green, item.bmi_blue],
        frailty: [item.frailty_red, item.frailty_yellow, item.frailty_green, item.frailty_blue]
      };
    });
  }

  // 上一月 = 較舊，下一月 = 較新
  get hasPrev(): boolean {
    return isMonthInRange(shiftMonth(this.selectedMonth, -1));
  }

  get hasNext(): boolean {
    return isMonthInRange(shiftMonth(this.selectedMonth, 1));
  }

  formatMonth(ym: string): string {
    const [y, m] = ym.split('-').map(Number);
    return `${y}年${m}月`;
  }

  step(delta: number) {
    const next = shiftMonth(this.selectedMonth, delta);
    if (isMonthInRange(next)) this.selectedMonth = next;
  }

  retry() {
    countyCommunityMapHistoryModule.fetchMonth({ ym: this.selectedMonth, silent: false });
  }

  async created() {
    // 若寫死的起始月晚於「上個月」，至少把選取月份夾回合法範圍
    if (monthToIndex(this.selectedMonth) < monthToIndex(MAP_HISTORY_START_MONTH)) {
      this.selectedMonth = MAP_HISTORY_START_MONTH;
    }
    await countyCommunityMapHistoryModule.selectMonth(this.selectedMonth);
  }

  // 不用 immediate：首次載入由 created() 處理
  @Watch('selectedMonth')
  onMonthChange(ym: string) {
    countyCommunityMapHistoryModule.selectMonth(ym);
  }

  // 根據 R 計數回傳顏色類別 (>=10 紅, >=5 黃)
  getMetricColorClass(RYGBL_data: number[]): string {
    const R_count = RYGBL_data[0];

    if (R_count >= 10) {
      return 'highlight-red';
    }
    else if (R_count >= 5) {
      return 'highlight-yellow';
    }
    return 'highlight-green';
  }

  // 根據 B 計數回傳象限邊框類別
  getQuadrantBorderClass(RYGBL_data: number[], index: number): string {
    const B_count = RYGBL_data[3];
    const isBlue = B_count >= 5;
    return `quad-border-${index} ${isBlue ? 'blue-border' : 'default-border'}`;
  }
}
